import { Box, Typography } from '@mui/material'
import { parseISO } from 'date-fns'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import TextTruncate from 'react-text-truncate'

import { useSiteConfiguration } from '@hapana/shared/web/hooks/siteConfiguration.hooks'
import { defaultTimeZoneFormat } from '@hapana/shared/utils/date.util'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

import { styles } from './notes-properties.styles'
import ModalOpenNote from './modals/modal-open-note.component'

const NoteWithBadge = ({ /* edited, badgeEdited, badge, */ date, description }) => {
  const { data } = useSiteConfiguration()
  const { t } = useTranslation(['checkIn'])
  const { pushDialog } = useDialog()
  // const [anchorEl, setAnchorEl] = useState(null)
  // const open = Boolean(anchorEl)
  // const { pushDialog } = useDialog()
  // const { t } = useTranslation(['checkIn'])

  // const renderNoteActionMenu = () => {
  //   return (
  //     <Menu anchorEl={anchorEl} data-testid="noteActionMenu" open={open} onClose={handleClose}>
  //       <MenuItem
  //         onClick={() => {
  //           pushDialog(AddEditNote, {
  //             showEditTitle: true,
  //             description,
  //             name: ALERTS_MOCK_DATA.username,
  //           })
  //         }}
  //       >
  //         <SvgIcon sx={styles.editIcon}>
  //           <PenIcon />
  //         </SvgIcon>
  //         <Typography typography="medium" color="gray.80" sx={styles.noteActionOption}>
  //           {t('checkIn:alerts.notesAndPropertiesAlerts.actionToNote.editNote')}
  //         </Typography>
  //       </MenuItem>
  //       <MenuItem
  //         onClick={() => {
  //           pushDialog(ModalOpenNote, {
  //             title: t('checkIn:alerts.title'),
  //             description,
  //             name: ALERTS_MOCK_DATA.username,
  //           })
  //         }}
  //       >
  //         <SvgIcon sx={styles.openNote}>
  //           <OpenNoteIcon />
  //         </SvgIcon>
  //         <Typography typography="medium" color="gray.80" sx={styles.noteActionOption}>
  //           {t('checkIn:alerts.notesAndPropertiesAlerts.actionToNote.openNote')}
  //         </Typography>
  //       </MenuItem>
  //       <Divider />
  //       <MenuItem
  //         onClick={() => {
  //           pushDialog(ModalDeleteNote)
  //         }}
  //       >
  //         <SvgIcon sx={styles.deleteNote}>
  //           <DeleteNoteIcon />
  //         </SvgIcon>
  //         <Typography typography="medium" color="gray.80" sx={styles.noteActionOption}>
  //           {t('checkIn:alerts.notesAndPropertiesAlerts.actionToNote.deleteNote')}
  //         </Typography>
  //       </MenuItem>
  //     </Menu>
  //   )
  // }

  // const handleClick = event => {
  //   setAnchorEl(event.currentTarget)
  // }
  // const handleClose = () => {
  //   setAnchorEl(null)
  // }

  const formattedDate = defaultTimeZoneFormat(parseISO(date), data?.timezone)

  const handleViewNote = useCallback(() => {
    pushDialog(ModalOpenNote, {
      title: t('checkIn:alerts.title'),
      description,
      date: formattedDate,
    })
  }, [description, formattedDate, pushDialog, t])
  return (
    <>
      <Box sx={styles.notewithBadgeContainer}>
        <Box>
          <Box sx={styles.noteDetailContainer}>
            <Typography typography="header4" color="gray.80" sx={styles.date}>
              {formattedDate}
            </Typography>
            {/* We won't have filters or be able to edit/delete alerts on iteration 2 */}
            {/* <Box sx={styles.chipContainer}>
              <Box type="span" sx={styles.chipStyle}>
                {badge && <Chip label={badge} size={CHIP_SIZE.SMALL} />}
              </Box>
              {edited && (
                <Chip
                  label={badgeEdited}
                  size={CHIP_SIZE.SMALL}
                  variant={CHIP_VARIANT.FILTER}
                  disabled
                />
              )}
            </Box> */}
          </Box>
        </Box>
        <Typography typography="header4" sx={styles.viewAllType} onClick={handleViewNote}>
          {t('checkIn:alerts.viewNote')}
        </Typography>
        {/* <SvgIcon onClick={handleClick} id="note-option-icon" sx={styles.optionIcon}>
          <OptionIcon />
        </SvgIcon> */}
        {/* {renderNoteActionMenu()} */}
      </Box>
      <Typography typography="medium" color="gray.80" sx={styles.description}>
        <TextTruncate
          line={2}
          element="span"
          truncateText=""
          text={description}
          textTruncateChild="..."
        />
      </Typography>
    </>
  )
}

NoteWithBadge.propTypes = {
  id: PropTypes.string,
  edited: PropTypes.bool,
  badgeEdited: PropTypes.string,
  badge: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
}

NoteWithBadge.defaultProps = {
  id: '',
  edited: false,
  badgeEdited: '',
  badge: '',
  date: '',
  description: '',
}

export default NoteWithBadge
